var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneralmanagerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_42610)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1797_42610",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1797_42610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5586 14.7518C12.4171 14.8632 14.161 15.128 15.0836 15.5387C16.097 15.9899 16.7499 16.9953 16.7499 18.1046V18.7147",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 22.6777V20.5983",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2266 22.6777V20.5983",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91406 5.45596V7.92804C4.91406 7.92804 5.95434 7.91571 6.30621 8.26268C6.3802 8.33564 6.50515 8.28417 6.50515 8.18031V6.55519C6.50515 5.99092 6.9626 5.53348 7.52686 5.53348H7.53915C7.70819 5.53348 7.87534 5.55956 8.03518 5.60992C8.33923 5.7057 8.65411 5.7631 8.97289 5.7631H9.09913C9.41792 5.7631 9.73279 5.7057 10.0368 5.60992C10.1967 5.55956 10.3638 5.53348 10.5329 5.53348H10.5452C11.1094 5.53348 11.5669 5.99092 11.5669 6.55519V8.06258C11.5669 8.21477 11.6902 8.33813 11.8424 8.33813H11.8436C12.0771 8.33813 12.3041 8.27024 12.5055 8.15199C12.8207 7.96701 13.158 7.92804 13.158 7.92804V5.92449C13.158 4.41784 11.9366 3.19649 10.4299 3.19649H7.6165C7.10289 3.19649 6.66637 3.52572 6.5061 3.98463C6.44603 4.15663 6.28184 4.27037 6.09961 4.27037C5.44486 4.27037 4.91406 4.80116 4.91406 5.45596Z",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92021 7.92856C4.7125 8.03646 4.57031 8.25315 4.57031 8.5034V9.22124C4.57031 9.57899 4.86035 9.86903 5.21815 9.86903H5.46312C5.48331 10.8092 5.87837 11.7141 6.59212 12.3287C7.1667 12.8234 7.97443 13.2552 9.04138 13.2672C10.1083 13.2552 10.916 12.8234 11.4906 12.3287C12.2043 11.7141 12.5994 10.8092 12.6196 9.86903H12.8646C13.2223 9.86903 13.5124 9.57899 13.5124 9.22124V8.5034C13.5124 8.25324 13.3703 8.03654 13.1627 7.92865",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03727 14.8185C5.53191 14.8924 5.34792 15.5267 5.73546 15.8594L7.18406 17.1027C7.39259 17.2818 7.69659 17.2947 7.91964 17.1342L9.03846 16.3286",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03906 16.3286L10.1579 17.1341C10.3809 17.2947 10.6849 17.2818 10.8934 17.1028L12.3421 15.8594C12.7296 15.5267 12.5456 14.8925 12.0403 14.8185L11.5595 14.7522",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01505 12.6539V14.1792C7.01505 14.4694 6.79957 14.7143 6.51172 14.7516",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5502 14.7516C11.2623 14.7143 11.0469 14.4694 11.0469 14.1792V12.6539",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7476 18.875V21.3089C16.7476 22.0649 16.1347 22.6777 15.3787 22.6777H2.69303C1.93704 22.6777 1.32422 22.0649 1.32422 21.3089V18.1047C1.32422 16.9954 1.97709 15.9901 2.99042 15.5389C3.913 15.1281 5.65693 14.8633 6.51545 14.7519L9.03591 16.3283L11.5563 14.7519",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62109 17.8772L10.1503 17.1338",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92188 17.1338L8.45104 17.8772",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2751 22.6777L9.62563 17.8772H8.44635L7.79688 22.6777",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3775 11.0349C12.4075 11.077 12.4404 11.1176 12.478 11.1553L12.8359 11.5131C13.204 11.8813 13.801 11.8813 14.1691 11.5131C14.7002 10.982 15.6082 11.3582 15.6082 12.1092C15.6082 12.6298 16.0303 13.0519 16.5509 13.0519H17.057C17.5777 13.0519 17.9997 12.6298 17.9997 12.1092C17.9997 11.3582 18.9078 10.982 19.4388 11.5131C19.807 11.8813 20.4039 11.8813 20.772 11.5131L21.1299 11.1553C21.4981 10.7871 21.4981 10.1902 21.1299 9.82209C20.5996 9.29186 20.9738 8.38577 21.7225 8.38294C22.2431 8.38101 22.6687 7.98131 22.6687 7.46074V6.91367C22.6687 6.3931 22.2431 5.9934 21.7225 5.99143C20.9738 5.98859 20.5996 5.08255 21.1299 4.55232H21.1299C21.4981 4.18416 21.4981 3.58728 21.1299 3.21913L20.7576 2.84676C20.3894 2.47864 19.8058 2.49704 19.4364 2.86373C18.9049 3.39117 17.9997 3.01502 17.9997 2.26518C17.9997 1.74452 17.5777 1.32244 17.057 1.32244H16.5509C16.0303 1.32244 15.6082 1.74452 15.6082 2.26518C15.6082 3.01623 14.7002 3.39233 14.1691 2.86124C13.801 2.49308 13.204 2.49308 12.8359 2.86124L12.478 3.21913C12.3003 3.39684 12.2092 3.62789 12.2031 3.86078M19.3337 7.35186C19.254 8.61351 18.2303 9.63724 16.9686 9.71695C15.4388 9.81363 14.1775 8.55236 14.2742 7.02251C14.354 5.7609 15.3777 4.73717 16.6393 4.65746C18.1692 4.56078 19.4304 5.822 19.3337 7.35186Z",
    stroke: "#202842",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_42610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralmanagerIcon);
export default __webpack_public_path__ + "static/media/generalmanagerIcon.1e1ac8c452eba44334cb05a808e26f56.svg";
export { ForwardRef as ReactComponent };